module.exports = __webpack_public_path__ + "img/IScout64_ua.6604e852.webp";